"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Panel-Widget mit optionaler Toolbar (oben) und optionaler Actionbar (unten).
 *
 * @class
 * @extents gc.gis.widget.GCWidget
 * @memberof gc.gis.widget
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {Object<string,*>} [options.toolbar] Toolbaroptionen
 * @param {Object<string,*>} [options.actionbar] Actionbaroptionen
 */
gc.gis.widget.GCPanel = function( options )
{
	gc.gis.widget.GCWidget.call( this, options );

	/**
	 * @type {Object<string,*>}
	 */
	this.toolbar   = options.toolbar;
	/**
	 * @type {Object<string,*>}
	 */
	this.actionbar = options.actionbar;

	// UI-Elemente
	/**
	 * @type {gc.gis.widget.GCWidgetGroup}
     */
	this.element_toolbar = undefined;
	/**
	 * @type {jQuery}
     */
	this.element_content = undefined;
	/**
	 * @type {gc.gis.widget.GCWidgetGroup}
	 */
	this.element_actionbar = undefined;
};
gc.gis.widget.GCPanel.prototype = Object.create( gc.gis.widget.GCWidget.prototype );

/**
 * @inheritdoc
 */
gc.gis.widget.GCPanel.prototype._render = function()
{
	var self = this;

	// Item-Container
	if( !this.element )
	{
		this.element = jQuery('<div>', {
			'class': 'gc-widget-panel'
				+ (self.alignment ? ' '+ self.alignment : '')
				+ (self.className ? ' '+ self.className : '')
		});
		if( this.id )
		{
			this.element.attr('id', this.id );
		}
	}
	else
	{
		this.element.children().remove();
	}

	// Toolbar
	if(this.toolbar)
	{
		this.toolbar.containerClassName = this.toolbar.containerClassName ?
			(this.toolbar.containerClassName + ' gc-widget-panel-toolbar') : 'gc-widget-panel-toolbar';
		this.element_toolbar = new gc.gis.widget.GCWidgetGroup(this.toolbar);
		this.element.append(this.element_toolbar.getElement());
	}

	// Content
	this.element_content = jQuery('<div>',{
		'class': 'gc-widget-panel-content'
	});
	this.element.append(this.element_content);

	// Actionbar
	if(this.actionbar)
	{
		this.actionbar.containerClassName = this.actionbar.containerClassName ?
			(this.actionbar.containerClassName + ' gc-widget-panel-actionbar') : 'gc-widget-panel-actionbar';
		this.element_actionbar = new gc.gis.widget.GCWidgetGroup( this.actionbar );
		this.element.append( this.element_actionbar.getElement() );
	}

	// Ggf. an target andocken
	if( this.target )
	{
		var container = jQuery( this.target );
		if( container.length )
		{
			container.append( this.element );
		}
		else
		{
			container = jQuery('<div>', {
				id: self.target.replace(/^#/,''),
				html: self.element
			});

			gc.gis.iface.getElement().append( container );
		}
	}

	return this.element;
};

/**
 * @public
 * @method
 * @return gc.gis.widget.GCWidgetGroup
 */
gc.gis.widget.GCPanel.prototype.getToolbar = function()
{
	return this.element_toolbar;
};

/**
 * @public
 * @method
 * @return gc.gis.widget.GCWidgetGroup
 */
gc.gis.widget.GCPanel.prototype.getActionbar = function()
{
	return this.element_actionbar;
};
